@file:OptIn(InternalResourceApi::class)

package battleships.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/battleships.shared.generated.resources/"

@delegate:ResourceContentHash(894_558_738)
internal val Res.drawable.big_ship1: DrawableResource by lazy {
      DrawableResource("drawable:big_ship1", setOf(
        ResourceItem(setOf(), "${MD}drawable/big_ship1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_286_799_997)
internal val Res.drawable.big_ship2: DrawableResource by lazy {
      DrawableResource("drawable:big_ship2", setOf(
        ResourceItem(setOf(), "${MD}drawable/big_ship2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_079_008_448)
internal val Res.drawable.med_ship1: DrawableResource by lazy {
      DrawableResource("drawable:med_ship1", setOf(
        ResourceItem(setOf(), "${MD}drawable/med_ship1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_467_690_765)
internal val Res.drawable.med_ship2: DrawableResource by lazy {
      DrawableResource("drawable:med_ship2", setOf(
        ResourceItem(setOf(), "${MD}drawable/med_ship2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-825_936_000)
internal val Res.drawable.ocean: DrawableResource by lazy {
      DrawableResource("drawable:ocean", setOf(
        ResourceItem(setOf(), "${MD}drawable/ocean.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_065_810_723)
internal val Res.drawable.small_ship1: DrawableResource by lazy {
      DrawableResource("drawable:small_ship1", setOf(
        ResourceItem(setOf(), "${MD}drawable/small_ship1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_015_108_421)
internal val Res.drawable.small_ship2: DrawableResource by lazy {
      DrawableResource("drawable:small_ship2", setOf(
        ResourceItem(setOf(), "${MD}drawable/small_ship2.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("big_ship1", Res.drawable.big_ship1)
  map.put("big_ship2", Res.drawable.big_ship2)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("med_ship1", Res.drawable.med_ship1)
  map.put("med_ship2", Res.drawable.med_ship2)
  map.put("ocean", Res.drawable.ocean)
  map.put("small_ship1", Res.drawable.small_ship1)
  map.put("small_ship2", Res.drawable.small_ship2)
}
